// test2568
(2568 && 0);
